<template>
    <div class="af3-main-loop-fiter-bar" :style="!mobileMode ? { top: props.options.floor_plans_loop_sticky_filter_bar_top + 'px' } : {}"
         ref="filterBarRef"
         v-bind="mobileMode ? {
           role: 'dialog',
           'aria-modal': 'true',
           'aria-hidden': !props.is_filter_by_mobile_open,
           'aria-label': 'Filter Options',
           tabindex: -1
         } : {}">

      <div class="af3-main-loop-fiter-bar-back-button">
        <button @click="handleBackButtonClick"
                aria-label="Close filter menu"
                class="af3-main-loop-fiter-bar-back-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="6.182" height="10.95" viewBox="0 0 6.182 10.95" aria-hidden="true">
            <path id="Path_46144" data-name="Path 46144" d="M9.89,5.475,5.122.707.354,5.475l-.707-.707L5.122-.707,10.6,4.768Z" transform="translate(0.707 10.597) rotate(-90)" />
          </svg>
          <span>GO BACK</span>
        </button>
      </div>

      <div class="af3-main-loop-fiter-bar-inner-container"
           role="region"
           aria-label="Filter Options">
      
        <div class="af3-shotcoder-filter-bar-group af3-shotcoder-filter-calendar" 
             v-if="props.options.floor_plans_loop_show_move_in_date_filter"
             role="group"
             aria-labelledby="move-in-date-label">
          <label id="move-in-date-label" for="af3-shotcoder-filter-bar-slider-price">MOVE-IN DATE</label>
          <filter-bar-calendar-component 
            :available-date="urlHasAvailabilityDate ? pendingForm.availability_date : null"
            @update:available-date="updateAvailabilityDate"
          />
        </div>

        <div class="af3-shotcoder-filter-bar-group af3-shotcoder-filter-lease-term" v-if="props.options.floor_plans_loop_show_lease_term_filter">
          <label for="af3-shotcoder-filter-bar-lease-term">LEASE TERM</label>
          <filter-bar-lease-terms-component 
            :available_lease_terms="available_lease_terms"
            v-model="pendingForm.lease_term"
          />
        </div>

        <div class="af3-shotcoder-filter-bar-group af3-shotcoder-filter-bar-slider" v-if="props.options.floor_plans_loop_show_price_filter">
          <label for="af3-shotcoder-filter-bar-slider-price">Price</label>
           <number-range-component 
           id="af3-shotcoder-filter-bar-slider-price"
           :min="props.price_min" 
           :max="props.price_max" 
           :is_price="true" 
           :value-min="urlHasPriceMin ? pendingForm.price_min : null"
           :value-max="urlHasPriceMax ? pendingForm.price_max : null"
           @update:min="updatePriceMin"
           @update:max="updatePriceMax"
           />
        </div>

        <div class="af3-shotcoder-filter-bar-group af3-shotcoder-filter-bar-numbers" v-if="props.options.floor_plans_loop_show_bedrooms_bathrooms_filter">
         <number-buttons-component 
           :min="props.bedrooms_min" 
           :max="props.bedrooms_max"
           :available_values="props.available_bedrooms"
           :type="'bedrooms'" 
           :value="urlHasBedroomsValue ? pendingForm.bedrooms_value : null"
           @update:value="updateBedroomsValue"
         />
         <number-buttons-component 
           :min="props.bathrooms_min" 
           :max="props.bathrooms_max"
           :available_values="props.available_bathrooms"
           :type="'bathrooms'" 
           :value="urlHasBathroomsValue ? pendingForm.bathrooms_value : null"
           @update:value="updateBathroomsValue"
         />
        </div>

        <div class="af3-shotcoder-filter-bar-group af3-shotcoder-filter-bar-slider" v-if="props.options.floor_plans_loop_show_size_filter">
          <label for="af3-shotcoder-filter-bar-slider-size">Size (SQ FT)</label>
           <number-range-component 
           id="af3-shotcoder-filter-bar-slider-size"
           :min="props.size_min" 
           :max="props.size_max" 
           :is_price="false" 
           :value-min="urlHasSizeMin ? pendingForm.size_min : null"
           :value-max="urlHasSizeMax ? pendingForm.size_max : null"
           @update:min="updateSizeMin"
           @update:max="updateSizeMax"
           />
        </div>

        <div class="af3-shotcoder-filter-bar-footer">
          
          <div v-if="options.floor_plans_loop_show_available_only_checkbox" 
               class="af3-shotcoder-filter-bar-sold-out-checkbox"
               role="group"
               aria-labelledby="available-only-label">
            <input type="checkbox" 
                   v-model="pendingForm.show_available_only" 
                   id="af3-shotcoder-filter-bar-available-only-checkbox"
                   aria-labelledby="available-only-label" />
            <label id="available-only-label" for="af3-shotcoder-filter-bar-available-only-checkbox">Show Available Only</label>
          </div>

          <button 
            class="af3-shotcoder-filter-bar-clear-button" 
            type="button"
            @click="clearFilters"
            aria-label="Clear all filters">
            Clear Filters
          </button>
        </div>
      </div>

      <button 
        class="af3-shotcoder-filter-bar-search-button" 
        type="button"
        @click="applyFilters"
        aria-label="Apply filters and see results">
        SEE RESULTS
      </button>
    </div>
</template>
  
<script>

import { defineComponent, ref, watch, onMounted, reactive, onBeforeUnmount, nextTick, computed } from 'vue';
import NumberRangeComponent from './NumberRangeComponent.vue';
import NumberButtonsComponent from './NumberButtonsComponent.vue';
import FilterBarCalendarComponent from './FilterBarCalendarComponent.vue';
import FilterBarLeaseTermsComponent from './FilterBarLeaseTermsComponent.vue';

export default defineComponent({
    components: { NumberRangeComponent, NumberButtonsComponent, FilterBarCalendarComponent, FilterBarLeaseTermsComponent },
   
    props: {
      options: {
        type: Object,
        required: true
      },
      price_min: {
        type: Number,
        required: true
      },
      price_max: {
        type: Number,
        required: true
      },
      bathrooms_min: {
        type: Number,
        required: true
      },
      bathrooms_max: {
        type: Number,
        required: true
      },
      bedrooms_min: {
        type: Number,
        required: true
      },
      bedrooms_max: {
        type: Number,
        required: true
      },
      size_min: {
        type: Number,
        required: true
      },
      size_max: {
        type: Number,
        required: true
      },
      sort_by: {
        type: String,
        required: true
      },
      available_bedrooms: {
        type: Array,
        required: true
      },
      available_bathrooms: {
        type: Array,
        required: true
      },
      available_lease_terms: {
        type: Array,
        required: false
      },
      is_filter_by_mobile_open: {
        type: Boolean,
        required: true
      },
      resources_url: {
        type: String,
        required: true
      }
    },
   
    setup(props, { emit }) {
      // Flags to track if URL has params
      const urlHasPriceMin = ref(false);
      const urlHasPriceMax = ref(false);
      const urlHasSizeMin = ref(false);
      const urlHasSizeMax = ref(false);
      const urlHasBedroomsValue = ref(false);
      const urlHasBathroomsValue = ref(false);
      const urlHasAvailabilityDate = ref(false);
      
      // Actual form that is used for filtering
      const form = reactive({
        price_min: props.price_min,
        price_max: props.price_max,
        bathrooms_value: null,
        bedrooms_value: null,
        size_min: props.size_min,
        size_max: props.size_max,
        show_available_only: props.options.floor_plans_loop_show_sold_out ? false : true,
        sort_by: props.sort_by,
        availability_date: null,
        lease_term: ''
      });

      // Pending form for storing changes until search button is clicked
      const pendingForm = reactive({
        price_min: props.price_min,
        price_max: props.price_max,
        bathrooms_value: null,
        bedrooms_value: null,
        size_min: props.size_min,
        size_max: props.size_max,
        show_available_only: props.options.floor_plans_loop_show_sold_out ? false : true,
        availability_date: null,
        lease_term: ''
      });

      const filterBarRef = ref(null);
     

      // Flag to track if we're in the initial setup phase
      const isInitializing = ref(true);

      // Responsive detection for mobile/desktop
      const isMobile = ref(false);
      const checkMobile = () => {
        isMobile.value = window.innerWidth < 1024;
      };
      onMounted(() => {
        checkMobile();
        window.addEventListener('resize', checkMobile);
      });
      onBeforeUnmount(() => {
        window.removeEventListener('resize', checkMobile);
      });
      const mobileMode = computed(() => isMobile.value);

      // Dynamically set filter bar and inner container heights on mobile
      const setFilterBarHeights = () => {
        if (!filterBarRef.value || !mobileMode.value) return;
        // Set filter bar height to visible viewport
        const vh = window.innerHeight;
        filterBarRef.value.style.height = vh + 'px';
        // Get top and bottom button heights
        const topBtn = filterBarRef.value.querySelector('.af3-main-loop-fiter-bar-back-button');
        const bottomBtn = filterBarRef.value.querySelector('.af3-shotcoder-filter-bar-search-button');
        const topBtnHeight = topBtn ? topBtn.offsetHeight : 0;
        const bottomBtnHeight = bottomBtn ? bottomBtn.offsetHeight : 0;
        // Calculate inner container height
        const innerHeight = vh - topBtnHeight - bottomBtnHeight;
        filterBarRef.value.style.setProperty('--af3-inner-container-height', innerHeight + 'px');
      };

      onMounted(() => {
        console.log("FilterBarComponent mounted with props:", props.price_min, props.price_max);
        
        const url = new URL(window.location.href);
        const params = url.searchParams;
        
        // Process price min/max from URL if available
        if (params.has('price_min')) {
          urlHasPriceMin.value = true;
          const value = Number(params.get('price_min'));
          form.price_min = value;
          pendingForm.price_min = value;
        } else {
          urlHasPriceMin.value = false;
          pendingForm.price_min = props.price_min;
          form.price_min = props.price_min;
        }
        
        if (params.has('price_max')) {
          urlHasPriceMax.value = true;
          const value = Number(params.get('price_max'));
          form.price_max = value;
          pendingForm.price_max = value;
        } else {
          urlHasPriceMax.value = false;
          pendingForm.price_max = props.price_max;
          form.price_max = props.price_max;
        }
        
        // Handle bedrooms and bathrooms using single values
        if (params.has('bedrooms_value')) {
          urlHasBedroomsValue.value = true;
          const value = params.get('bedrooms_value') === 'null' ? null : Number(params.get('bedrooms_value'));
          form.bedrooms_value = value;
          pendingForm.bedrooms_value = value;
        }
        
        if (params.has('bathrooms_value')) {
          urlHasBathroomsValue.value = true;
          const value = params.get('bathrooms_value') === 'null' ? null : Number(params.get('bathrooms_value'));
          form.bathrooms_value = value;
          pendingForm.bathrooms_value = value;
        }
        
        if (params.has('size_min')) {
          urlHasSizeMin.value = true;
          const value = Number(params.get('size_min'));
          form.size_min = value;
          pendingForm.size_min = value;
        } else {
          urlHasSizeMin.value = false;
          pendingForm.size_min = props.size_min;
          form.size_min = props.size_min;
        }
        
        if (params.has('size_max')) {
          urlHasSizeMax.value = true;
          const value = Number(params.get('size_max'));
          form.size_max = value;
          pendingForm.size_max = value;
        } else {
          urlHasSizeMax.value = false;
          pendingForm.size_max = props.size_max;
          form.size_max = props.size_max;
        }
        
        if (params.has('sort_by')) {
          form.sort_by = params.get('sort_by');
        }
        
        // Handle boolean parameter separately
        if (params.has('show_available_only')) {
          const value = params.get('show_available_only') === 'true';
          form.show_available_only = value;
          pendingForm.show_available_only = value;
        }
        
        // Process availability_date from URL if available
        if (params.has('availability_date')) {
          urlHasAvailabilityDate.value = true;
          const value = params.get('availability_date');
          form.availability_date = value;
          pendingForm.availability_date = value;
        }
        
        // Process lease_term from URL if available, otherwise use default from af3_options
        if (params.has('lease_term')) {
          const value = params.get('lease_term');
          form.lease_term = value;
          pendingForm.lease_term = value;
        } else if (props.options.default_lease_term && props.options.default_lease_term !== '0' && props.available_lease_terms && props.available_lease_terms.length > 0) {
          // Find the matching lease term composite_key from the default_lease_term slug
          const defaultSlug = props.options.default_lease_term;
          const matchingTerm = props.available_lease_terms.find(term => {
            const termSlug = term.lease_term_name.toLowerCase()
              .replace(/&.+?;/g, '')
              .replace(/[^a-z0-9\s-]/g, '')
              .replace(/\s+/g, '-')
              .replace(/-+/g, '-')
              .replace(/^-+|-+$/g, '')
              + '-' + term.start_date + '-' + term.end_date;
            return termSlug === defaultSlug;
          });
          if (matchingTerm) {
            form.lease_term = matchingTerm.composite_key;
            pendingForm.lease_term = matchingTerm.composite_key;
          }
        }
        
        emit('filterBySelected', form);
        
        // After initialization is complete, set flag to false
        nextTick(() => {
          isInitializing.value = false;
        });

        window.addEventListener('resize', setFilterBarHeights);
        window.addEventListener('orientationchange', setFilterBarHeights);
        watch(() => props.is_filter_by_mobile_open, (open) => {
          if (open) nextTick(setFilterBarHeights);
        }, { immediate: true });
      });

      // Only watch for changes to sort_by in the form
      watch(() => form.sort_by, (newValue) => {
        if (!isInitializing.value) {
          // Update URL for sort_by
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', newValue);
          window.history.pushState({}, '', url);
          
          // Emit the filter event for sort_by changes
          emit('filterBySelected', form);
        }
      });

      // Watch for prop changes to update the sort_by value
      watch(() => props.sort_by, (newValue) => {
        form.sort_by = newValue;
      });

      // Watch for mobile filter bar visibility
      watch(() => props.is_filter_by_mobile_open, (newValue) => {
        if (!filterBarRef.value) return;
        
        if (newValue) {
          document.body.style.overflow = 'hidden';
          filterBarRef.value.style.display = 'flex';
          // Focus the first focusable element when opening
          nextTick(() => {
            const firstFocusable = filterBarRef.value?.querySelector(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            if (firstFocusable) {
              firstFocusable.focus();
            }
          });
          requestAnimationFrame(() => {
            if (filterBarRef.value) {
              filterBarRef.value.classList.add('af3-main-loop-fiter-bar-open');
            }
          });
        } else {
          document.body.style.overflow = '';
          filterBarRef.value.classList.remove('af3-main-loop-fiter-bar-open');
          const timeoutId = setTimeout(() => {
            if (filterBarRef.value && !props.is_filter_by_mobile_open) {
              filterBarRef.value.style.display = 'none';
            }
          }, 500);
          
          onBeforeUnmount(() => {
            clearTimeout(timeoutId);
          });
        }
      }, { immediate: true });

      // Handle keyboard navigation
      const handleKeyDown = (event) => {
        if (event.key === 'Escape' && props.is_filter_by_mobile_open) {
          emit('filterByMobileClose');
        }
      };

      // Focus trap for mobile filter bar
      const handleTabKey = (event) => {
        if (!props.is_filter_by_mobile_open) return;

        const focusableElements = filterBarRef.value?.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        
        if (!focusableElements?.length) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            event.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            event.preventDefault();
          }
        }
      };

      // Add and remove event listeners
      onMounted(() => {
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('keydown', handleTabKey);
      });

      onBeforeUnmount(() => {
        document.removeEventListener('keydown', handleKeyDown);
        document.removeEventListener('keydown', handleTabKey);
        document.body.style.overflow = '';
        window.removeEventListener('resize', setFilterBarHeights);
        window.removeEventListener('orientationchange', setFilterBarHeights);
      });

      const handleBackButtonClick = () => {
        emit('filterByMobileClose');
      }

      
      const updatePriceMin = (value) => {
        pendingForm.price_min = Number(value);
        urlHasPriceMin.value = true; // Set the flag to true since the user has interacted with the slider
      };

      const updatePriceMax = (value) => {
        pendingForm.price_max = Number(value);
        urlHasPriceMax.value = true; // Set the flag to true since the user has interacted with the slider
      };

      const updateBedroomsValue = (value) => {
        console.log(`Updating bedrooms value to: ${value} (type: ${typeof value})`);
        // If value is min-1 or null, treat as "Any"
        if (value === null || value === props.bedrooms_min - 1) {
          pendingForm.bedrooms_value = null;
          console.log('Setting bedrooms_value to null (Any)');
        } else {
          pendingForm.bedrooms_value = value;
        }
        urlHasBedroomsValue.value = true;
      };
      
      const updateBathroomsValue = (value) => {
        console.log(`Updating bathrooms value to: ${value} (type: ${typeof value})`);
        // If value is min-1 or null, treat as "Any"
        if (value === null || value === props.bathrooms_min - 1) {
          pendingForm.bathrooms_value = null;
          console.log('Setting bathrooms_value to null (Any)');
        } else {
          pendingForm.bathrooms_value = value;
        }
        urlHasBathroomsValue.value = true;
      };

      const updateSizeMin = (value) => {
        pendingForm.size_min = Number(value);
        urlHasSizeMin.value = true; // Set the flag to true since the user has interacted with the slider
      };

      const updateSizeMax = (value) => {
        pendingForm.size_max = Number(value);
        urlHasSizeMax.value = true; // Set the flag to true since the user has interacted with the slider
      };

      const updateAvailabilityDate = (value) => {
        console.log(`Updating availability date to: ${value}`);
        pendingForm.availability_date = value;
        urlHasAvailabilityDate.value = true;
      };

      const clearFilters = () => {
        // Reset form values to props defaults
        pendingForm.price_min = props.price_min;
        pendingForm.price_max = props.price_max;
        pendingForm.bathrooms_value = null;
        pendingForm.bedrooms_value = null;
        pendingForm.size_min = props.size_min;
        pendingForm.size_max = props.size_max;
        pendingForm.availability_date = null;
        pendingForm.lease_term = '';
        // Reset show_available_only to default value
        pendingForm.show_available_only = props.options.floor_plans_loop_show_sold_out ? false : true;
        
        // Apply the reset values to the actual form
        form.price_min = props.price_min;
        form.price_max = props.price_max;
        form.bathrooms_value = null;
        form.bedrooms_value = null;
        form.size_min = props.size_min;
        form.size_max = props.size_max;
        form.availability_date = null;
        form.lease_term = '';
        // Reset show_available_only to default value
        form.show_available_only = props.options.floor_plans_loop_show_sold_out ? false : true;
        
        // Reset URL flags
        urlHasPriceMin.value = false;
        urlHasPriceMax.value = false;
        urlHasSizeMin.value = false;
        urlHasSizeMax.value = false;
        urlHasBedroomsValue.value = false;
        urlHasBathroomsValue.value = false;
        urlHasAvailabilityDate.value = false;
        
        // Update URL by removing the filter parameters (but keep sort_by)
        const url = new URL(window.location.href);
        url.searchParams.delete('price_min');
        url.searchParams.delete('price_max');
        url.searchParams.delete('bathrooms_value');
        url.searchParams.delete('bedrooms_value');
        url.searchParams.delete('size_min');
        url.searchParams.delete('size_max');
        url.searchParams.delete('availability_date');
        url.searchParams.delete('lease_term');
        url.searchParams.delete('show_available_only');
        
        window.history.pushState({}, '', url);
        
        // Emit event with updated form values
        emit('filterBySelected', form);

        // Close the filter bar after clearing filters
        emit('filterByMobileClose');
      };
      
      // Function to apply filter changes when search button is clicked
      const applyFilters = () => {
        // Copy values from pendingForm to form (except sort_by which is handled separately)
        form.price_min = pendingForm.price_min;
        form.price_max = pendingForm.price_max;
        form.bathrooms_value = pendingForm.bathrooms_value;
        form.bedrooms_value = pendingForm.bedrooms_value;
        form.size_min = pendingForm.size_min;
        form.size_max = pendingForm.size_max;
        form.show_available_only = pendingForm.show_available_only;
        form.availability_date = pendingForm.availability_date;
        form.lease_term = pendingForm.lease_term;
        
        console.log('Applying filters with form values:', { ...form });
        
        // Update URL for all form values
        const url = new URL(window.location.href);
        
        // Handle numeric and boolean values
        for (const [key, value] of Object.entries(form)) {
          if (key === 'sort_by') continue; // Sort is handled separately
          
          console.log(`Setting URL param: ${key} = ${value} (type: ${typeof value})`);
          
          // Skip null values and -1 values (which represent "Any")
          if (value === null || value === -1) {
            console.log(`Removing ${key} from URL because it's null or -1 (Any)`);
            url.searchParams.delete(key);
          } else if (typeof value === 'boolean') {
            url.searchParams.set(key, String(value));
          } else {
            url.searchParams.set(key, value);
          }
        }
        
        // Make sure sort_by is always in the URL
        url.searchParams.set('sort_by', form.sort_by);
        
        // Log the final URL for debugging
        console.log('New URL will be:', url.toString());
        
        window.history.pushState({}, '', url);
        
        // Emit the filter event with updated form values
        emit('filterBySelected', form);

        // Close the filter bar after applying filters
        emit('filterByMobileClose');

        // Scroll to the top of the page
        console.log('Scrolling to the top of the page');
        handleBackToTop();
      };

      const handleBackToTop = () => {
        let headerheight = props.options.floor_plans_loop_sticky_filter_bar_top;
        const container = document.querySelector('#af3-shortcodes-floor-plan-page-main-component');
        if (container) {
          const rect = container.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const elementTop = rect.top + scrollTop;
          
          window.scrollTo({
            top: elementTop - headerheight,
            behavior: 'smooth'
          });
        }
      }

    return { 
      props,
      form,
      pendingForm,
      urlHasPriceMin,
      urlHasPriceMax,
      urlHasSizeMin,
      urlHasSizeMax,
      urlHasBedroomsValue,
      urlHasBathroomsValue,
      urlHasAvailabilityDate,
      isInitializing,
      filterBarRef,
      handleBackButtonClick,
      updatePriceMin,
      updatePriceMax,
      updateSizeMin,
      updateSizeMax,
      updateBedroomsValue,
      updateBathroomsValue,
      updateAvailabilityDate,
      applyFilters,
      clearFilters,
      mobileMode
     };
  },
});
</script>